import React from 'react';
import { View, Text, Image, StyleProp, ViewStyle } from 'react-native';
import * as API from 'generated/api';
import * as FFChat from 'model/FFChat';

interface Props {
  chat: API.FFPublicChat;
  users: API.MinimalUser[];
  chatKey: string;
  style: StyleProp<ViewStyle>;
}

const NavBar = ({ style, ...props }: Props) => {
  let url = props.chatKey ? `https://open.muze.chat/view?scroll=${props.chatKey}` : 'https://open.muze.chat'
  return (
  <View
    style={[
      {
        alignSelf: 'center',
        flex: 1,
        overflow: 'hidden',
        height: 70,
        backgroundColor: 'white',
        borderBottomColor: 'rgba(0, 0, 0, 0.1)',
        borderBottomWidth: 0.5,
      },
      style,
    ]}
  >
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
          paddingVertical: 12,
          paddingHorizontal: 21,
        }}
      >
        {props.chat.profileImageSmall && (
          <View>
            <Image
              source={{
                uri: props.chat.profileImageSmall,
                width: 40,
                height: 40,
              }}
              style={{
                borderRadius: 4,
                marginEnd: 16,
              }}
            />
          </View>
        )}
        <View
          style={{
            height: '100%',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'space-around',
          }}
        >
          <Text
            style={{
              margin: 0,
              fontWeight: 'bold',
              fontFamily: 'Caros, sans-serif',
              fontSize: 16,
            }}
          >
            {FFChat.displayName(props.chat)}
          </Text>
          <Text
            style={{
              margin: 0,
              fontWeight: '300',
              fontFamily: 'Caros, sans-serif',
              fontSize: 12,
              color: 'rgba(0, 0, 0, 0.3)',
            }}
          >
            <a
              href={url}
              style={{color: '#4B85F4'}}
            >
              made on muze
            </a>
          </Text>
        </View>
        <View
          style={{
            height: '100%',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'flex-end',
          }}
        >
          <a
            href={url}
            style={{
              color: '#FFFFFF', 
              textDecoration: 'none',
              backgroundColor: '#5983EC',
              borderRadius: '6px',
              padding: '6px 10px',  
              margin: 0,
              fontWeight: 600,
              fontFamily: 'Caros, sans-serif',
              fontSize: 16,
          }}
          >
            Open in App
          </a>
        </View>
      </View>
  </View>
)}

NavBar.defaultProps = {
  style: null,
};

export default NavBar;
